import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Styles.css";
import kcIcon from "../../assets/icons/kingschat.png";

import { auth, googleProvider } from "../../firebase";
import { signInWithPopup, signInWithRedirect } from "firebase/auth";

const KINGSCHAT_CLIENT_ID = process.env.REACT_APP_KINGSCHAT_CLIENT_ID || "409892e9-24a8-45b9-a23c-e2cb22f377d8";
const API_URL = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || "https://ceindiazone2.in");

const SignIn = () => {
  const [userInput, setUserInput] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {


      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      const payload = {
        email: user.email,
        name: user.displayName || "Google User",
        googleId: user.uid,
        deviceModel: navigator.userAgent,
        platform: "Web",
        macAddress: null
      };
      
      const response = await fetch(`${API_URL}/api/auth/google-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || `Backend returned status ${response.status}`);
      }
      
      const data = await response.json();
      if (data && (data.id || data.currentSessionToken)) {
        localStorage.setItem("user", JSON.stringify(data));
        if (data.role === 'ADMIN') {
          localStorage.setItem("adminUser", JSON.stringify(data));
          alert(`Welcome Admin ${data.name}`);
          window.location.href = "/admin/dashboard";
        } else {
          alert(`Welcome ${data.name}`);
          const redirectUrl = sessionStorage.getItem('loginRedirect') || '/';
          sessionStorage.removeItem('loginRedirect');
          window.location.href = redirectUrl;
        }
      } else {
        throw new Error("Invalid user response from backend");
      }
    } catch (error) {
      console.error("Google sign-in error:", error);
      // Fallback to redirect if popup fails or is blocked on mobile
      try {
        await signInWithRedirect(auth, googleProvider);
      } catch (redirectErr) {
        alert("Google sign-in failed: " + redirectErr.message);
      }
    }
  };


  const handleKingsChatLogin = () => {
    setIsLoading(true);
    sessionStorage.setItem("login_provider", "kingschat");
    const redirectUri = "https://ceindiazone2.in";
    const authUrl = `https://accounts.kingschat.online/log-in?clientId=${KINGSCHAT_CLIENT_ID}&redirectUri=${encodeURIComponent(redirectUri)}`;
    window.location.href = authUrl;
  };

  // Note: OAuth callback processing (hash token extraction) has been moved entirely to AuthHandler.jsx.
  // This prevents race conditions and duplicate fetch calls.

  const handleLogin = async (e) => {
    e.preventDefault();

    const payload = {
      email: userInput.includes("@") ? userInput : null,
      phone: !userInput.includes("@") ? userInput : null,
      password: password,
      macAddress: null
    };

    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("Invalid credentials");
      }

      const data = await res.json();
      console.log("Login response:", data);
      localStorage.setItem("user", JSON.stringify(data)); // Save user session

      // Check for Admin role and redirect to portal
      if (data.role === 'ADMIN') {
        localStorage.setItem("adminUser", JSON.stringify(data));
        alert(`Welcome Admin ${data.name}`);
        window.location.href = "/admin/dashboard";
      } else {
        alert(`Welcome ${data.name}`);
        const redirectUrl = sessionStorage.getItem('loginRedirect') || '/';
        sessionStorage.removeItem('loginRedirect');
        window.location.href = redirectUrl;
      }
    } catch (err) {
      console.error("Login failed", err);
      alert("Login failed: " + err.message);
    }
  };

  return (
    <div className="signin-container">
      <button className="back-btn" onClick={() => navigate('/')}>
        ←
      </button>

      {/* Left Side (Image + Text) */}
      <div className="signin-left">
        <div className="signin-left-content">
          <h1>Welcome Back</h1>
          <p>Login to access your account and manage your projects!</p>
        </div>
      </div>

      {/* Right Side (Login Form) */}
      <div className="signin-right">
        <h2>Sign In</h2>
        <p style={{ fontSize: '0.85rem', color: '#ffcc00', marginBottom: '15px', textAlign: 'center' }}>
          Phone number login coming soon. For now, sign in with your email address.
        </p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <input
              type="text"
              placeholder="Email or Phone"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              required
            />
          </div>
          <div className="form-group" style={{ position: 'relative' }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ paddingRight: '45px' }}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2rem'
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
          <button type="submit" className="login-btn">
            Sign In →
          </button>
        </form>

        <div className="forgot-password-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
          <Link to="/forgot-password" style={{ fontSize: '0.85rem', color: '#888', textDecoration: 'none' }}>
            Forgot password?
          </Link>
        </div>

        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <p className="or-text">or</p>
          <button 
            type="button" 
            className="kingschat-btn" 
            onClick={handleKingsChatLogin} 
            disabled={isLoading} 
            style={{
              width: '100%',
              padding: '12px',
              marginBottom: '12px',
              borderRadius: '8px',
              border: 'none',
              background: 'linear-gradient(135deg, #0052cc 0%, #0066ff 100%)',
              color: 'white',
              fontWeight: '700',
              fontSize: '14px',
              cursor: isLoading ? 'wait' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              boxShadow: '0 4px 14px rgba(0, 102, 255, 0.35)',
              transition: 'all 0.3s ease'
            }}
          >
            <img src={kcIcon} alt="KingsChat" width="22" height="22" style={{ objectFit: 'contain' }} />
            {isLoading ? 'Connecting to KingsChat...' : 'Login through KingsChat'}
          </button>
          <button type="button" className="google-btn" onClick={handleGoogleLogin} style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid #ddd',
            backgroundColor: 'white',
            color: '#555',
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}>
            <img src="https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg" alt="Google" width="20" />
            Sign in with Google
          </button>
        </div>

        <p className="or-text">Don't have an account?<span> <Link to="/signup" className="toggle-btn">
          Sign Up
        </Link></span></p>

      </div>
    </div>
  );
};

export default SignIn;
